import React,{FC, useState, useEffect, useRef} from "react";
import { PageTitle } from "../../../../_metronic/layout/core";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { Card, Col, Row, Image, Dropdown } from "react-bootstrap";
import { Tabs, Tab } from "react-bootstrap";
import TradePotentialByPartnerTable from './components/TradePotentialByPartnerTable';
import { HS_DIGITS } from "../../../libs/constant";
import TradePotentialByProductTable from "./components/TradePotentialByProductTable";
import { DetailProductModal } from "./components/DetailProductModal";

const TradePotentialPage: FC =  () => {
  const intl = useIntl()
  const [activeTab, setActiveTab] = useState<string>('countries')
  const [selectedHSDigit, setSelectedHSDigit] = useState(HS_DIGITS[HS_DIGITS.length-1])
  const [modalVisible, setModalVisible] = useState(false);
  const [modalData, setModalData] = useState<any>(null);

  const availableHSDigits: any[] = HS_DIGITS.slice(1, HS_DIGITS.length)

  const handleHSDigitChange = (hsDigit) =>{
    setSelectedHSDigit(hsDigit)
  }

  const handleToggleModal = (data:any, hs:string) => {
    setModalData({
      data,
      hs
    });
    setModalVisible(prev => !prev);
  }

  return (<>
      <PageTitle breadcrumbs={[{
        title: 'Home',
        path: '/',
        isSeparator: false,
        isActive: false,
      },
      {
        title: '',
        path: '',
        isSeparator: true,
        isActive: false,
      },]}>{intl.formatMessage({id: 'MENU.TRADE_POTENTIAL'})}
      </PageTitle>
      <Row className="mb-5">
        <Col>
          <Card className="card-custom card-border">
            <Card.Body className="d-flex justify-content-around align-items-center">
              <Image src="/media/tina/img-result-market.jpg" thumbnail width={110}/>
              <div  className="ms-5 d-flex flex-column justify-content-center">
                <h3 className="text-primary">Trade Prospects
                  <span className="text-gray-700">
                    <span className="fa-solid fa-angles-right px-1"></span>
                    evaluate the trade prospects for Cambodia
                  </span> 
                </h3>
                <div className="text-gray-700">Explore trade prospects by trade partner or product. The results are based on partial equilibrium simulations with partner economies modelled iteratively to remove tariffs on all products using 2023 data. For economy-level results, click on any economy to go to the simulation page to re-run the liberalization scenarios to view detailed product-level results. For product-level table, the results are summed up by across all individual economy simulations for each product – click on any hs code to see details. Note some totals may be slightly different due to rounding errors, total imports only include products for which tariff data is available. 
                </div>
              </div>
            </Card.Body>
          </Card>  
        </Col>
      </Row>
      <Row className="mb-5">
        <Col>
          <Card>
            <Card.Header className="card-header-stretch">
              <Card.Title>
                <span className="fa fa-magnifying-glass px-2"></span>
                <h3 className='text-gray-700'>List of Potential Trade Partner and Commodity</h3>   
              </Card.Title>
              <div className="d-flex align-items-center justify-content-between gx-5">
                {activeTab === 'commodities' && (
                  <div className="card-toolbar"> {/* Wrap in a div with card-toolbar class */}
                    <Dropdown className="me-1">
                      <Dropdown.Toggle variant="label-brand" id="hs-digit-dropdown" className="btn btn-sm btn-bold btn-label-brand dropdown-toggle fw-bold">
                        {selectedHSDigit.label}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {
                          availableHSDigits.map(digit => {
                            return (<Dropdown.Item key={digit.value} onClick={() => handleHSDigitChange(digit)}>{digit.label}</Dropdown.Item>)
                          })
                        }
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                )}
              </div>
            </Card.Header>  
            <Card.Body>
              <Tabs defaultActiveKey="countries" id="trade-potential-tabs" className="mb-3" onSelect={(k) => setActiveTab(k as string)}>
                <Tab eventKey="countries" title="List of Trade Partner">
                  <TradePotentialByPartnerTable/>
                </Tab>
                <Tab eventKey="commodities" title="List of Product">
                  <TradePotentialByProductTable digit={selectedHSDigit} modalHandler={(data, hs)=>handleToggleModal(data, hs)}/>
                </Tab>
              </Tabs>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <DetailProductModal data={modalData} show={modalVisible} onToggle={()=>handleToggleModal(null,'')}/>
    </>)
}

export default TradePotentialPage